import { Content, Header, Page } from '@backstage/core-components';
import { PlatformInsightsCard } from './PlatformInsightsCard';

export const PlatformInsightsPage = () => {
  return (
    <Page themeId="tool">
      <Header title="Platform Insights" subtitle="Usage metrics and statistics" />
      <Content>
        <PlatformInsightsCard />
      </Content>
    </Page>
  );
};
